<template>
  <section class="h_11">
    <m-img
      class="title_container"
      src="@/v2/mobile/assets/image/h_11_title.svg"
    />
    <!-- 轮播图 -->
    <div class="img_slider" ref="sliderContainer">
      <div
        class="img_container border_container_light"
        v-ia
        @touchstart="onTouchStart"
        @touchmove="onTouchMove"
        @touchend="onTouchEnd"
      >
        <slider
          ref="slider"
          v-model="sliderActiveIndex"
          :controlBtn="false"
          :indicators="false"
          :interval="3000"
          :autoplay="autoplay"
          :touch="true"
          height="100%"
          width="100%"
        >
          <slider-item v-for="(i, index) in assetsList" :key="index">
            <m-img :src="i" class="slider_img" />
          </slider-item>
        </slider>
      </div>
      <div class="alive_indicators">
        <div
          v-for="(i, index) in assetsList"
          :key="index"
          class="slider_indicators"
          :class="`slider_indicators_${index} ${
            index === sliderActiveIndex && 'slider_indicators_active'
          }`"
          @click.passive="indicatorsClick(index)"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import swipeMixin from '@/v2/mobile/mixins/swipeMixin.js'
import { domVisibleArea } from '@/utils'
export default {
  name: 'Weather',
  mixins: [swipeMixin],
  data() {
    return {
      sliderActiveIndex: 0,
      autoplay: false,
      assetsList: [
        require('@/v2/auto/assets/image/33/0.jpg'),
        require('@/v2/auto/assets/image/33/1.jpg'),
        require('@/v2/auto/assets/image/33/2.jpg'),
        require('@/v2/auto/assets/image/33/3.jpg'),
      ],
    }
  },
  watch: {
    sliderActiveIndex(current) {
      this.$gsap.to(`.slider_indicators`, {
        width: 8,
        backgroundColor: '#00000024',
        duration: 0.5,
      })
      this.$gsap.to(`.slider_indicators_${current}`, {
        width: 34,
        backgroundColor: '#1368fb',
        duration: 0.5,
      })
    },
  },
  methods: {
    sliderChange(index) {
      this.sliderActiveIndex = index
    },
    indicatorsClick(index) {
      this.sliderActiveIndex = index
    },
  },

  mounted() {
    // 配置滑动混入
    this.setSwipeConfig({
      index: 'sliderActiveIndex',
      total: 'assetsList',
      enableLoop: true,
      minDistance: 50,
    })
    domVisibleArea(this.$refs.sliderContainer, 1, () => {
      this.autoplay = true
      setTimeout(() => {
        this.sliderActiveIndex = 1
      }, 3000)
    })
    // 设置初始指示器状态
    this.$gsap.to(`.slider_indicators_${this.sliderActiveIndex}`, {
      width: 34,
      backgroundColor: '#1368fb',
      duration: 0.5,
    })
  },
}
</script>

<style lang="less" scoped>
.h_11 {
  position: relative;
  overflow: hidden;
  background-color: #fff;
  margin-top: -5px;
  height: 100%;
  padding-bottom: 100px;
  .title_container {
    width: calc(100% - 48px);
    margin: 0 24px;
    margin-bottom: 30px;
  }
  .img_slider {
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 24px;
    width: calc(100% - 48px);
    .img_container {
      position: relative;
      z-index: 98;
      overflow: hidden;
      width: 100%;
      aspect-ratio: 16/10;
    }
  }
  .alive_indicators {
    margin-top: 14px;
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 5px;
    height: 20px;
    .slider_indicators {
      width: 8px;
      height: 8px;
      background-color: #00000024;
      border-radius: 20px;
      cursor: pointer;
    }
    .slider_indicators_active {
      background-color: #1368fb;
    }
  }
}
</style>
